import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import { useTitle } from "../hooks/useTitle";
import { useProductos } from "../hooks/useProductos";
import CarritoCompras from "../components/CarritoCompras";
import { useForm } from "../hooks/useForm";

import { routes } from "../helpers/Routes";
import { enqueueSnackbar } from "notistack";
import PaymentForm from "../components/PaymentForm";
import styled from 'styled-components'
import { Button, Typography, Box } from "@mui/material";
import { RemoveRounded, AddRounded, ShoppingCart } from "@mui/icons-material";
import BuyButton from "../components/BuyButton";
import namer from 'color-namer';

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  margin-top: 100px;
  background-color: #000000;
`

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
`

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 2rem;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`

const Card = styled.div`
  background-color: #222;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
`

const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1rem;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: #333;
  padding: 15px;
  border-radius: 5px;
  border: ${props => props.isActive ? '2px solid #fff' : '2px solid transparent'};
`

const CheckboxLabel = styled.label`
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  margin-left: 0.5rem;
  cursor: pointer;
  ${props => props.isActive && 'color: #fff; font-weight: bold;'}
`

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  margin-bottom: 0.5rem;
`

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 1rem;


`

const ScrollArea = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-right: 1rem;
`

const OrderItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

const ItemDetails = styled.div`
  flex: 1;
`

const ItemName = styled.h3`
  font-weight: 600;
  margin: 0;
`

const ItemInfo = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.25rem 0 0;
`

const ItemPrice = styled.p`
  font-weight: 500;
`

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
`

const ShippingSection = styled.div`
  border: 1px solid #444;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
`

const ShippingTitle = styled.h3`
  color: #fff;
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.2rem;
`

// Mock data for the cart items
const cartItems = [
  { id: 1, name: "Mountain Bike Pro", size: "M", price: 1299.99, quantity: 1 },
  { id: 2, name: "Road Bike Elite", size: "L", price: 1599.99, quantity: 1 },
  { id: 3, name: "City Cruiser", size: "S", price: 599.99, quantity: 2 },
]
function Checkout() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openCart, setOpenCart] = useState(false);
  const { cart = [], postOrdenes, formatoCOP, getCart } = useProductos();
  const [shipping, setShipping] = useState(120000);
  const [isPickup, setIsPickup] = useState(false);
  const totalPagar = cart?.reduce((sum, item) => sum + item?.price * item?.cantidad, 0) || 0;

  useEffect(() => {
    getCart();
  }, []);
  
  const { form, onChange } = useForm({ fullName: "", nombreEmpresa: "", pais: "Colombia", departamento: "", ciudad: "", calle: "", codigoZIP: "", email: "", telephone: "", total: totalPagar, cedula: '' });
  const { fullName, nombreEmpresa, pais, departamento, ciudad, calle, codigoZIP, email, telephone, total } = form;




  // Toggle pickup option
  const handlePickupToggle = () => {
    setIsPickup(!isPickup);
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (Object.values(form).some(value => value.trim() === "")) {
      alert("All fields are required")
      return
    }
    // Here you would typically send the order to your backend
    console.log("Order submitted:", form)
    // router.push("/confirmation")
  }

    const handlerPayment = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Validar campos obligatorios según el método de entrega
      if (!form.fullName?.trim()) throw new Error("El nombre completo es obligatorio");
      if (!form.email?.trim()) throw new Error("El email es obligatorio");
      if (!form.telephone?.trim()) throw new Error("El teléfono es obligatorio");
      if (!form.cedula?.trim()) throw new Error("La cédula es obligatoria");
      if (!form.pais?.trim()) throw new Error("El país es obligatorio");

      // Validar campos adicionales solo si no es recogida en tienda
      if (!isPickup) {
        if (!form.calle?.trim()) throw new Error("La dirección es obligatoria para envíos");
        if (!form.ciudad?.trim()) throw new Error("La ciudad es obligatoria para envíos");
        if (!form.departamento?.trim()) throw new Error("El estado/departamento es obligatorio para envíos");
      }

      // Calculate final shipping cost based on pickup selection
      const finalShipping = isPickup ? 0 : shipping;

      // 1. Crear la orden en el backend
      const orderData = {
        firstName: form.fullName.split(' ')[0],
        lastName: form.fullName.split(' ').slice(1).join(' '),
        cedula: form.cedula,
        email: form.email,
        phone: form.telephone,
        address: isPickup ? "" : form.calle,
        city: isPickup ? "" : form.ciudad,
        postalCode: form.codigoZIP || "",
        country: form.pais,
        deliveryMethod: isPickup ? "pickup" : "delivery",
        cart: cart.map(item => ({
          id: item.id,
          type: item.type || "bicycle",
          quantity: item.cantidad,
          id_usuario: form.cedula // Usando la cédula como id_usuario
        })),
        shippingPrice: finalShipping,
        totalPrice: totalPagar + finalShipping
      };

      const order = await postOrdenes(orderData);
      console.log(order)
      if (!order || !order.id) {
        throw new Error('Error al crear la orden');
      }

      // 2. Configurar ePayco
      if (!window.ePayco) {
        throw new Error('ePayco no está disponible');
      }

      const handler = window.ePayco.checkout.configure({
        key: import.meta.env.VITE_PUBLIC_KEY,
        test: false
      });

      // 3. Preparar datos para ePayco
      const paymentData = {
        name: "Orden #" + order.id.toString(),
        description: cart.map(item => item.name).join(', '),
        invoice: order.id.toString(),
        currency: "cop",
        amount: (totalPagar + finalShipping).toString(),
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "es",
        external: "false",
        name_billing: form.fullName,
        address_billing: form.calle || 'Recogida en tienda',
        type_doc_billing: "cc",
        mobilephone_billing: form.telephone,
        number_doc_billing: form.cedula,
        email_billing: form.email
      };

      console.log(paymentData)
      // 4. Iniciar el proceso de pago
      await handler.open(paymentData);

    } catch (error) {
      console.error('Error en el proceso de pago:', error);
      enqueueSnackbar(error.message || 'Hubo un error al procesar el pago', {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        }
      });
      setError(error.message || 'Hubo un error al procesar el pago');
    } finally {
      setLoading(false);
    }
  };


  function NameColor(item){
    try {
      const color = namer(item?.color)?.basic[0]?.name
      return color
    } catch (error) {
      return item?.color
    }
  }

  return (
    <div>
      <Header setOpenCart={setOpenCart} openCart={openCart} />
      <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
      <PageContainer>

        <ContentWrapper >
          <Grid>
            <Card>
              <CardTitle>Detalles de la Orden</CardTitle>
              <Form onSubmit={handleSubmit}>
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="fullName">Nombre Completo</Label>
                    <Input id="fullName" name="fullName" value={fullName} onChange={(event) => onChange(event, "fullName")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="companyName">Nombre de Compañía (opcional)</Label>
                    <Input id="companyName" name="companyName" value={nombreEmpresa} onChange={(event) => onChange(event, "nombreEmpresa")} />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="country">País</Label>
                  <Input id="country" name="country" value={pais} onChange={(event) => onChange(event, "pais")} required readOnly />
                </FormGroup>
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="state">Estado</Label>
                    <Input id="state" name="state" value={departamento} onChange={(event) => onChange(event, "departamento")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="ciudad">Ciudad</Label>
                    <Input id="ciudad" name="ciudad" value={ciudad} onChange={(event) => onChange(event, "ciudad")} required />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="country">Calle</Label>
                  <Input id="calle" name="calle" value={calle} onChange={(event) => onChange(event, "calle")} required />
                </FormGroup>
                         
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="zipCode">Codigo Postal (ZIP Code, opcional)</Label>
                    <Input id="zipCode" name="zipCode" value={codigoZIP} onChange={(event) => onChange(event, "codigoZIP")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="phone">Phone</Label>
                    <Input id="phone" name="phone" value={telephone} onChange={(event) => onChange(event, "telephone")} required />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="email">Cedula</Label>
                  <Input id="cedula" name="cedula" type="text" value={form.cedula} onChange={(event) => onChange(event, "cedula")} required />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" name="email" type="email" value={email} onChange={(event) => onChange(event, "email")} required />
                </FormGroup>

                <BuyButton onClick={handlerPayment}>
                  Comprar Ahora
                </BuyButton>

              </Form>


            </Card>
            <div style={{ marginBottom: "40px" }}>

              <Card>
                <CardTitle>Pedido</CardTitle>
                <ScrollArea>
                  {cart?.map((item) => (
                    <OrderItem key={item?.id}>
                      <ItemDetails>
                        <ItemName>{item?.name}</ItemName>
                        <ItemInfo>Size: {item?.size}</ItemInfo>
                        <ItemInfo>Quantity: {item?.cantidad}</ItemInfo>
                        <ItemInfo> <div style={{ display: "flex", alignItems: "center"}}>
                               <span style={{ marginRight: "6px"}}>Color:</span>
                                     {item ? NameColor(item) : ""} 
                                     <span
                                      style={{
                                        display: "inline-block",
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: item?.color,
                                        borderRadius: "50%",
                                        marginLeft: "6px",
                                        border: "1px solid rgba(255,255,255,0.2)",
                                      }}
                                    ></span>

                                    </div></ItemInfo>
                      </ItemDetails>
                      <ItemPrice style={{ color: "green" }}>{formatoCOP.format(item?.price * item?.cantidad)}</ItemPrice>
                    </OrderItem>
                  ))}
                 
                </ScrollArea>
                  <OrderItem>
                    <ItemDetails>
                      Envio:
                    </ItemDetails>
                    <ItemPrice style={{ color: "green" }}>
                      {isPickup ? 'Gratis (Retiro en tienda)' : formatoCOP.format(shipping)}
                    </ItemPrice>
                  </OrderItem>
                <TotalRow>
        

                  <span>Total</span>
                  <span style={{ color: "green" }}>{formatoCOP.format(Number(isPickup ? 0 : shipping) + totalPagar)}</span>
                </TotalRow>
                <CheckboxGroup isActive={isPickup}>
                    <input
                      type="checkbox"
                      id="pickupOption"
                      checked={isPickup}
                      onChange={handlePickupToggle}
                    />
                    <CheckboxLabel htmlFor="pickupOption" isActive={isPickup}>
                      RECOGER EN TIENDA (sin costo de envío)
                    </CheckboxLabel>
                  </CheckboxGroup>

              </Card>
            </div>
          </Grid>
        </ContentWrapper>
        <Footer />
      </PageContainer>

    </div>
  )


}
export default Checkout

